import { ViewBody } from 'components/Sidebar'
import useGetData from 'hooks/useGetData'
import React, { useEffect, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import DocumentTemplatesList from './DocumentTemplatesList'
import styled from 'styled-components'
import Scrollbars from 'components/Scrollbars'
import Alert from 'components/Alert'
import DocumentTemplateItem from './DocumentTemplateItem'
import Loader from 'components/Loader'
import PathBreadcrumb from 'components/PathBreadcrumb'

const PathContainer = styled(ViewBody)`
  margin-top: 5px;
  margin-bottom: 10px;
`

const DocumentTemplatesListScrollbars = styled(Scrollbars)`
  display: flex;
  flex-direction: column;
`

type Props = {
  boardId: number;
  documentTemplateComponent?: React.ComponentType<React.ComponentProps<typeof DocumentTemplateItem>>;
  autoSelect?: boolean;
}

const DocumentTemplates: React.FC<Props> = ({
  boardId,
  documentTemplateComponent: DocumentTemplateComponent = DocumentTemplateItem,
  autoSelect,
}) => {
  const [path, setPath] = useState<any[]>([])

  const args = useMemo(() => ({
    boardId
  }), [boardId])
  const {
    data,
  }: {
    data: any
  } = useGetData('DocumentTemplateSources', args)

  useEffect(() => {
    if (autoSelect && data?.Sources.length === 1 && path.length === 0) {
      setPath([
        {
          documentTemplateSourceId: data.Sources[0].Id,
          name: data.Sources[0].Name,
          hidden: true,
        }
      ])
    }
  }, [autoSelect, data, path])

  return (
    data ? (
      data.Sources.length ? (
        <DocumentTemplatesListScrollbars>
          {path.length > 0 ? (
            <DocumentTemplatesList
              documentTemplateComponent={DocumentTemplateComponent}
              path={path}
              onPathChange={setPath}
            />
          ) : (
            <>
              <PathContainer>
                <PathBreadcrumb />
              </PathContainer>
              {data?.Sources.map((Source) =>
                <DocumentTemplateComponent
                  key={Source.Id}
                  type='source'
                  documentTemplateSourceId={Source.Id}
                  name={Source.Name}
                  url={Source.Url}
                  onClick={() => {
                    setPath([
                      {
                        documentTemplateSourceId: Source.Id,
                        name: Source.Name,
                      }
                    ])
                  }}
                />
              )}
            </>
          )}
        </DocumentTemplatesListScrollbars>
      ) : (
        <ViewBody>
          <Alert>
            <FormattedMessage id='DOCUMENT_TEMPLATE_SOURCES_NONE_IN_BOARD' />
          </Alert>
        </ViewBody>
      )
    ) : <Loader center />
  )
}

export default DocumentTemplates
